import React, { useState } from 'react';
import PropTypes from 'prop-types';
// components
import WidgetButtons from './WidgetButtons';
import CustomWidgetCard from './CustomWidgetCard';
// redux
import { useSelector } from '../../redux/store';
// hooks
import { useToggle } from '../../hooks';
// utils
import groupedTreatments from '../../utils/groupedTreatments';

const FTATableReportsWidget = ({ onWidgetClick, dateRangeProps, widgetToggle }) => {
    const { toggle: internalToggle, onOpen, onClose } = useToggle(true);
    const toggle = widgetToggle !== undefined ? widgetToggle : internalToggle;
    const { treatmentsList: { results } } = useSelector((state) => state.practiceTreatment);

    const [currentWidget, setCurrentWidget] = useState('');

    const treatments = groupedTreatments(results);

    const handleOpen = () => onOpen();

    const handleClose = () => onClose();

    const widgetArray = [
        { key: 'FAILED_TO_ATTEND', icon: '', value: '0', text: 'Total FTA\'s' },
        { key: '2', icon: '', value: 'invisalign', text: 'Total FTA\'s for Invisalign', isTreatment: true },
        { key: '3', icon: '', value: 'bonding', text: 'Total FTA\'s for Bonding', isTreatment: true },
        { key: '4', icon: '', value: 'implants', text: 'Total FTA\'s for Implants', isTreatment: true },
    ];

    const normalizeValues = (value) => (Array.isArray(value) ? value : [value]).filter(Boolean);

    const handleWidgetClick = (value, key) => {
        setCurrentWidget(key);
        const values = normalizeValues(value).map((val) => val?.toString?.().toLowerCase?.()).filter(Boolean);
        if (!values.length || values.every((val) => val === '0')) {
            onWidgetClick([]);
            return;
        }
        onWidgetClick(treatments.filter((ele) => {
            const name = ele.name?.toLowerCase?.() || '';
            return values.some((val) => name.includes(val));
        }));
    };

    return (
        <>
            {dateRangeProps && <WidgetButtons
                toggle={toggle}
                dateRangeProps={dateRangeProps}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />}
            {toggle && (
                <CustomWidgetCard handleWidgetClick={handleWidgetClick} widgetArray={widgetArray} currentWidget={currentWidget} />
            )}
        </>
    );
};

export default FTATableReportsWidget;

FTATableReportsWidget.propTypes = {
    onWidgetClick: PropTypes.func,
    dateRangeProps: PropTypes.any,
    widgetToggle: PropTypes.bool,
};
